<template>

  <div class="p-fluid report-field">
    <div :class="['p-grid report-field-header', {'report-field-header-small':section==='REPORT'}]">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label>{{$t('report.'+section+'.'+guide.label)}}</label>
      </div>
    </div>
    <div>

      <!-- <div v-if="!overview && embed" class="iframe-embedded" v-html="embed"></div> -->
      <div v-if="!overview" style="font-size: 1.1rem" class="p-pt-3 p-pb-3">
        <a :href="url" target="_blank">{{ text }}</a>
      </div>

      <span v-else><a :href="url" target="_blank">{{ text }}</a></span>

    </div>
  </div>

</template>

<script>
export default {
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      overview: Boolean
    },
  data() {
    return {
      text: null,
      url: null,
      embed: null
    }
  },
  computed: {
  },
  created() {
    this.initLink();
  },
  mounted() {
  },
  watch: {
    '$i18n.locale': 'initLink'
  },
  methods: {
    initLink() {
      let loc = this.$functions.locale(this.$i18n.locale);
      let link = this.guide.links[loc];
      if(link==null) {
        link = this.guide.links["en_GB"];
      }
      this.text = link.text;
      this.url = link.url;
      this.embed = link.embed;
    }
  }
}
</script>

<style scoped>

a {
  text-decoration: underline;
}



</style>